import React from 'react';

/**
 * One honest line about what is happening and what to do — never a spinner that
 * goes nowhere. `tone="quiet"` for "nothing here yet", loud for real failures.
 */
export const Notice: React.FC<{
  children: React.ReactNode;
  tone?: 'quiet' | 'error' | 'ok';
  action?: React.ReactNode;
  className?: string;
}> = ({ children, tone = 'error', action, className = '' }) => (
  <div
    role={tone === 'error' ? 'alert' : 'status'}
    className={`flex flex-wrap items-center gap-x-3 gap-y-1 rounded-xl px-3.5 py-2.5 text-[13px] ${
      tone === 'error'
        ? 'bg-primary-50 text-primary-700'
        : tone === 'ok'
          ? 'bg-emerald-50 text-emerald-700'
          : 'bg-neutral-50 text-neutral-600'
    } ${className}`}
  >
    <span className="min-w-0 flex-1">{children}</span>
    {action}
  </div>
);

/**
 * The kit switch is 24px tall; a pseudo-element widens what a thumb has to hit
 * without changing what the eye sees.
 */
export const THUMB_REACH = "before:absolute before:-inset-3 before:content-['']";
